import * as React from "react"
import type { SVGProps } from "react"
const SvgEdit = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M5 19.71h1.43l9.77-9.77-1.42-1.42L5 18.28zm-1 2a1 1 0 0 1-.71-.28A1 1 0 0 1 3 20.7v-2.4a2 2 0 0 1 .58-1.4L16.2 4.29q.3-.28.66-.43t.77-.15c.4 0 .52.05.77.15q.38.15.65.45l1.37 1.4q.3.28.44.65a2.2 2.2 0 0 1 0 1.52 2 2 0 0 1-.44.66l-12.6 12.6a2 2 0 0 1-1.4.57zM15.48 9.24l-.7-.72 1.42 1.42z" />
  </svg>
)
export default SvgEdit
